document.addEventListener("DOMContentLoaded", function () {

  (function () {
    const sliders = document.querySelectorAll(".product-card-swiper");
    if (!sliders.length) return;

    function loadSwiperCSS() {
      if (document.querySelector('link[href*="swiper-bundle.min.css"]')) {
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        link.onload = resolve;
        link.onerror = () => reject(new Error("Failed to load Swiper CSS"));
        document.head.appendChild(link);
      });
    }

    function loadSwiperJS() {
      if (window.Swiper) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        script.onload = resolve;
        script.onerror = () => reject(new Error("Failed to load Swiper JS"));
        document.body.appendChild(script);
      });
    }

    function initAllSliders() {
      document.querySelectorAll(".product-card-swiper").forEach(container => {
        if (container.swiper) return;

        container.swiper = new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoHeight: false,
          touchRatio: 0.5,
          preventClicks: true,
          preventClicksPropagation: true,
          observeParents: true,
          observeSlideChildren: true,
          navigation: {
            nextEl: container.querySelector(".swiper-button-next17"),
            prevEl: container.querySelector(".swiper-button-prev17"),
          },
        });
      });
    }

    loadSwiperCSS()
      .then(loadSwiperJS)
      .then(initAllSliders)
      .catch(err => console.warn("Swiper loading error:", err));

  })();

});